import * as I18n from 'i18n-js';

export function withPrefix(prefix) {
  const t = function (key: string, opt = {}): string {
    return I18n.t(`${prefix}.${key}`, opt);
  };

  return t;
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/src/i18n_helpers.ts